import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * Full-page error when PG contact invite profile prefetch fails or token is missing.
 */
const RegisterInviteLoadError = ({ onRetry, title, message }) => {
  const navigate = useNavigate();
  const primaryColor = "#333333";
  const secondaryColor = "#666666";

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#fafafa", p: 3 }}
      data-testid="register-invite-load-error"
    >
      <Typography variant="h5" sx={{ color: primaryColor, mb: 2 }}>
        {title}
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", mb: 3, textAlign: "center" }}>
        {message}
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2, alignItems: "center" }}>
        {onRetry ? (
          <Button
            variant="contained"
            onClick={onRetry}
            sx={{
              bgcolor: primaryColor,
              "&:hover": { bgcolor: secondaryColor },
            }}
          >
            Try Again
          </Button>
        ) : null}
        <Button variant="outlined" onClick={() => navigate("/")} sx={{ borderColor: primaryColor, color: primaryColor }}>
          Back to Login
        </Button>
      </Box>
    </Box>
  );
};

RegisterInviteLoadError.propTypes = {
  onRetry: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.string,
};

RegisterInviteLoadError.defaultProps = {
  title: "Unable to load registration form",
  message: "Please check your invite link or contact support for assistance.",
};

export default RegisterInviteLoadError;
